export enum recruitersTypes {
  FETCH_RECRUITERS_REQUEST = "FETCH_RECRUITERS_REQUEST",
  FETCH_RECRUITERS_SUCCESS = "FETCH_RECRUITERS_SUCCESS",
  FETCH_RECRUITERS_FAILURE = "FETCH_RECRUITERS_FAILURE",
}